export default __webpack_public_path__ + "static/media/cleanproStep4.0bf41303.png";